/**
 * TICKET-1036: classify a drain's droppedOps into which toast(s) AppShell should
 * show. Before this, the dropped-ops toast fired only when
 * `droppedOps.some(op => op.domain === 'photos')` — a dropped tasks/crm/quotes/
 * procurement op vanished with no user-visible sign at all. Keep the
 * photos-specific copy (it names the concrete recovery: retake/re-add) and add
 * a generic message for every other domain.
 * @param {Array<{domain?: string}>} droppedOps
 * @returns {{photos: boolean, other: boolean}}
 */
export function classifyDroppedOps(droppedOps) {
  const ops = Array.isArray(droppedOps) ? droppedOps : [];
  return {
    photos: ops.some((op) => op?.domain === 'photos'),
    other: ops.some((op) => op?.domain !== 'photos'),
  };
}
